import React from 'react';
import { Anchor, Card } from 'antd';

const PageAnchorNav = ({ anchorLinks, getScrollContainer }) => {
    return (
        <div style={{ position: 'sticky', top: '80px' }}>
            <Card title="On This Page" size="small">
                <Anchor items={anchorLinks} targetOffset={80} getContainer={getScrollContainer}/>
            </Card>
        </div>
    );
};

export default PageAnchorNav;
